// Password recovery — served by THIS project's backend, which updates the shared account.
const LOCAL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "") || window.location.origin;

async function call(path, init) {
  let res;
  try {
    res = await fetch(`${LOCAL}/api/password-reset${path}`, { headers: { "Content-Type": "application/json" }, ...init });
  } catch {
    throw new Error("Sem ligação ao servidor. Verifique a Internet e tente novamente.");
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Ocorreu um erro. Tente novamente.");
  return data;
}

export const requestReset = (email) => call("/request", { method: "POST", body: JSON.stringify({ email }) });
export const verifyReset = (token) => call(`/verify?token=${encodeURIComponent(token)}`);
export const confirmReset = (token, password) => call("/confirm", { method: "POST", body: JSON.stringify({ token, password }) });
